import React from 'react'
import {useDispatch} from 'react-redux'
import styled from 'styled-components'
import ButtonAtom from '../../to_forms/button/button.atom'
import TypographyAtom from '../typography/typography.atom'
import modal_errorStyles from './modal_error.styles'
import {hideModal} from '../../../store_redux/reducer/modal.reducer'

interface ModalErrorAtomProps {
  btnLabel: string
  errorMsg: string
}

const apAtomName = {ap_atom_name: 'apModalErrorAtom'}

const StyledWrapper = styled(props => <div {...props} />)`
  ${modal_errorStyles}
`

const ModalErrorAtom: React.FC<ModalErrorAtomProps> = function ({
  btnLabel,
  errorMsg,
}) {
  const dispatch = useDispatch()

  const handleClick = () => {
    dispatch(hideModal())
  }

  const parseString = () => errorMsg.replace(/\n/g, '<br />')

  return (
    <StyledWrapper {...apAtomName}>
      <div>
        <TypographyAtom
          ahd_type="sData"
          dangerouslySetInnerHTML={{__html: parseString()}}
        />
        <ButtonAtom ap_type="primary" onClick={handleClick}>
          {btnLabel}
        </ButtonAtom>
      </div>
    </StyledWrapper>
  )
}

export default ModalErrorAtom
